import React, { useCallback, useMemo } from 'react';
import { Form } from 'react-bootstrap-5';

import AsyncSelect from 'react-select/async';
import { components } from 'react-select';
import { debounce } from 'lodash';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';

import { searchContacts } from '../../../helpers/prospect_api';
import { CONTACT_MODEL } from '../../../constants';
import type { RootState } from '../../store/root_reducer';
import type { Activity, Ownerships, ConnectedRecord } from 'bundles/connect/types';


type MultiValueLabelProps = {
  data: {
    link?: string;
    connectedRecordType: string;
    connectedRecordId: number;
  }
}

const MultiValueLabel = (props: MultiValueLabelProps) => {
  const link = props.data.link;
  return (
    <div className="d-flex align-items-center gap-1 ps-2 privacy-mask">
      {link && (
        <a href={link} rel="noopener noreferrer" target="_blank">
          <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="sm" />
        </a>
      )}
      <components.MultiValueLabel {...props as any} />
    </div>
  );
};

type ContactInputProps = {
  activity: Activity;
  owners?: Ownerships[];
  onChange: (activity: Activity) => void;
}

const ownerToSelectOption = owner => (
  { connectedRecordId: owner.contact.id, label: owner.contact.name, connectedRecordType: CONTACT_MODEL }
);


function ContactInput({ activity, owners, onChange }: ContactInputProps) {
  const connectedRecords = activity.connectedRecordsAttributes;

  const handleContactChange = (values) => {
    onChange({ ...activity, connectedRecordsAttributes: values });
  };

  const promiseOptions = useCallback(debounce((inputValue, callback) => {
    searchContacts(inputValue).then((results) => {
      const contactsAndCompanies = [...results.contacts.hits, ...results.companies.hits];
      const options = contactsAndCompanies.map(result => (
        { connectedRecordId: result.id, label: result.name, connectedRecordType: result.type }
      ));
      callback(options);
    });
  }, 300), []);

  const defaultOptions = useMemo(() => (owners || []).map(ownerToSelectOption), [owners]);

  return (
    <Form.Group>
      <Form.Label>Contact</Form.Label>
      <AsyncSelect
        cacheOptions
        classNames={{
          multiValue: () => 'border-primary-focus',
        }}
        components={{ MultiValueLabel }}
        defaultOptions={defaultOptions}
        getOptionValue={option => option.connectedRecordId}
        isMulti
        loadOptions={promiseOptions}
        value={connectedRecords}
        onChange={handleContactChange}
      />
    </Form.Group>
  );
}

export default connect((state: RootState) => ({ owners: state.callConsoleData.owners || state.offMarketProperty.owners }), {})(ContactInput);
